"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TranslateText = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const translations_1 = require("../translations");
const TranslateText = (props) => {
    return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, translations_1.translate)(props.id, props.values) });
};
exports.TranslateText = TranslateText;
//# sourceMappingURL=translateText.js.map